// src/api.js
import axios from 'axios';
import {BACKEND_ENDPOINT} from "./const/appConst";

const axiosClient = axios.create({
    baseURL: `${BACKEND_ENDPOINT}`,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken'); // Get token from local storage
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refreshToken');
            const response = await axios.post(`${BACKEND_ENDPOINT}/auth/refresh-token`, { token: refreshToken });
            if (response.status === 200) {
                localStorage.setItem('accessToken', response.data.accessToken);
                localStorage.setItem('refreshToken', response.data.refreshToken);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.accessToken;
                return axiosClient(originalRequest);
            }
        }
        return Promise.reject(error);
    }
);

export default axiosClient;